import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";

import moment from "moment";

import { editNormalizationTags, getBaselinesFromTimestamp, setAsDefaultBaseline, getBaselines } from "api/baseline.js";

import getLogger from "utils/logger.util";
import { formatUTCofTimezone, fromatDateFromBaselineFormat } from "utils/utils";
import {
  BaselineStrings,
  InputErrorStrings,
  ToasterStatusStrings,
  userProfileStrings,
  valueStrings,
  BASELINE_TABLE_STRINGS,
  dialogStrings
} from "constants/constantStrings";
import { DATE_FORMAT_SMALL, DATE_TIME_SECONDS_FORMAT, LOCAL_TIME_ZONE } from "constants/globalConstants.js";

import BaselineReadMore from "pages/Baseline/BaselineReadMore.jsx";
import BaselineReadOnlyView from "pages/Baseline/BaselineReadOnlyView";
import { DatePickerConfig, TimePickerConfig } from "components/DatePopover/DateTimeConfig";
import DupontDatePicker from "components/DatePopover/DupontDatePicker";
import Dropdown from "components/Dropdown";
import DupontButton from "components/DupontButton";
import DupontDialog from "components/DupontDialog";
import InputBox from "components/InputBox";
import createNotification, { ERROR_NOTIFICATION } from "components/Notifications";
import TagDropdown from "components/TagDropdown";

import EditDefault from "assets/Other/editTag_default.svg";
import EditDisabled from "assets/Other/editTag_disabled.svg";
import ValidateDefault from "assets/Other/validate_arrow_default.svg";
import ValidateDisabled from "assets/Other/validate_arrow_disabled.svg";
import ValidateSuccess from "assets/Other/validate_tick_default.svg";

import { baseLineModalObj } from "./BaseLine.config";
import { addNewBaseline, getModalDataWithTagsMapping, parseBaslineTagsValue } from "./baseline.util";

import "./index.scss";

const Logger = getLogger("AddBaseLineModal");
let validateFields = { Timezone: LOCAL_TIME_ZONE, Date: "" };

export function AddBaseLineModal(props) {
  const {
    setIsBaselineFormOpen,
    isviewOnly,
    tagsList,
    setBaselines,
    baselines,
    isClone,
    editBaselineId,
    editBaselineType,
    baselineTimezone,
    editBaselineName,
    chartBaselineTimestamp
  } = props;
  const timezoneOptions = moment.tz.names();
  const { tagsAsObj } = useSelector(state => state.tags);

  const [baselineModal, setbaselineModal] = useState({});
  const [isCloneView, setIsCloneView] = useState(isClone);
  const [isViewOnlyView, setIsViewOnlyView] = useState(isviewOnly);
  const [isFetchReady, setIsFetchReady] = useState(false);
  const [validateSuccessfull, setValidateSuccessfull] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isTagsUpdated, setIsTagsUpdated] = useState(false);
  const [isEditTagsEnabled, setIsEditTagsEnabled] = useState(false);
  const [isAddEnabled, setIsAddEnabled] = useState(true);
  const [titleError, setTitleError] = useState("");
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSettingTimestamp, setIsSettingTimestamp] = useState(true);
  const [isDateTimeInvalid, setIsDateTimeInvalid] = useState(false);
  const { isAdmin } = useSelector(state => state.user);

  const isSettingManually = baselineModal.BaselineValuesSetting === "manually";
  const validateState =
    validateSuccessfull && isSettingTimestamp && !isFetchReady ? false : Boolean(isFetchReady && isSettingTimestamp && !isDateTimeInvalid);
  const editButtonImage = isSettingManually ? EditDefault : EditDisabled;
  const validateButtonImage =
    validateSuccessfull && isSettingTimestamp && baselineModal.Date && !isFetchReady
      ? ValidateSuccess
      : isFetchReady && isSettingTimestamp
      ? ValidateDefault
      : ValidateDisabled;
  const formatedChartBaselineTimestamp = moment(new Date(chartBaselineTimestamp)).format(DATE_TIME_SECONDS_FORMAT);

  const MAX_TITLE_LIMIT = 50;
  const MIN_TITLE_LIMIT = 5;

  const isTitleValid = value => {
    const valueLength = value.trim().length;

    if (valueLength < MIN_TITLE_LIMIT || valueLength > MAX_TITLE_LIMIT) {
      return false;
    } else if (!isUniqueTitleName(value)) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (chartBaselineTimestamp !== "" && chartBaselineTimestamp !== undefined) {
      onDateChangeManullay(fromatDateFromBaselineFormat(chartBaselineTimestamp));
    }
  }, [chartBaselineTimestamp]);

  useEffect(() => {
    if (baselineModal.Date && baselineModal.Timezone && chartBaselineTimestamp && !isFetchReady) {
      getBaselineValues();
    }
    if (baselineModal.NormalizationTags) {
      const empty = Object.values(baselineModal.NormalizationTags).filter(val => !val.value);
      setIsAddEnabled(Boolean((empty?.length > 0 || !isTitleValid(baselineModal.Title)) && !isViewOnlyView));
    }
  }, [baselineModal, isviewOnly]);

  useEffect(() => {
    validateFields.Timezone = baselineTimezone;
    const fetchInitialData = async () => {
      let modalData = JSON.parse(JSON.stringify({ ...baseLineModalObj, Timezone: baselineTimezone }));
      const isSettingTimestamp = modalData.BaselineValuesSetting === "timestamp";
      setIsSettingTimestamp(isSettingTimestamp);
      try {
        setIsLoading(true);
        modalData = await getModalDataWithTagsMapping(modalData, tagsAsObj, editBaselineId, editBaselineType);
        modalData.baselineID = editBaselineId;
        if (editBaselineId) checkIsTitleValid(modalData.Title);
      } catch (err) {
        Logger.log("Error while fetching tags mapping..", err);
      } finally {
        if (modalData.Date === "" && chartBaselineTimestamp !== "" && chartBaselineTimestamp !== undefined) {
          modalData.Date = fromatDateFromBaselineFormat(chartBaselineTimestamp);
        }
        setbaselineModal(modalData);
        setIsLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (selectedDate) {
      const dateString = selectedDate;
      setbaselineModal({ ...baselineModal, Date: dateString });
      validateFields.selectedDate = dateString;
      const isFetchReady = checkFetchReady(dateString);
      setIsFetchReady(isFetchReady);
      setValidateSuccessfull(false);
      setIsDateTimeInvalid(!moment(selectedDate, DATE_TIME_SECONDS_FORMAT, true).isValid());
    }
  }, [selectedDate]);

  useEffect(() => {
    if (errorMessage && errorMessage.length > 0 && isError) {
      setIsError(false);
      createNotification(ERROR_NOTIFICATION, errorMessage, ToasterStatusStrings.error);
    }
  }, [errorMessage]);

  const getBaselineValues = async () => {
    setIsError(false);
    const baselineTimestamp = formatUTCofTimezone(selectedDate, baselineModal.Timezone);
    if ((baselineModal.TimeStamp !== baselineTimestamp && !isDateTimeInvalid) || isTagsUpdated === true || isFetchReady) {
      try {
        setIsLoading(true);
        const response = await getBaselinesFromTimestamp(baselineTimestamp, baselineModal.Timezone);
        if (response.status >= 200 && response.status < 300) {
          const tagsValues = response.data;
          const tags = { ...baselineModal.NormalizationTags };
          const modalData = parseBaslineTagsValue(tags, tagsValues, selectedDate, baselineTimestamp);
          setbaselineModal({ ...baselineModal, ...modalData });
          if (baselineModal.Title === "") setTitleError(InputErrorStrings.required);
          setValidateSuccessfull(true);
          setIsFetchReady(false);
          const empty = Object.values(modalData.NormalizationTags).filter(val => !val.value);
          if (empty && empty.length > 0) {
            let error = "";
            setIsError(true);
            Object.entries(empty).forEach(tag => {
              error += tag[1].label + " ";
            });
            setErrorMessage(BaselineStrings.validationError.replace("[%]", error));
          }
        }
      } catch (err) {
        Logger.error("Error while retrieving data for selected timestamp: ", err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const checkFetchReady = date => {
    const { TimeStamp, Timezone } = baselineModal;
    return Boolean((TimeStamp || date || formatedChartBaselineTimestamp) && Timezone);
  };

  const handleCloseBaselineForm = async data => {
    let success = null;
    if (data === dialogStrings.confirm) {
      if (isViewOnlyView) {
        setIsViewOnlyView(false);
        setIsCloneView(true);
      } else {
        setIsAddEnabled(true);
        success = await handleAddBaseline();
      }
    } else if (data === dialogStrings.setAsDefault) {
      try {
        setIsLoading(true);
        const response = await setAsDefaultBaseline(baselineModal.baselineID);
        if (response) {
          setIsCloneView(false);
          setIsViewOnlyView(false);
          setIsBaselineFormOpen(false);
          const response = await getBaselines();
          if (response && response.data && response.status >= 200 && response.status < 300) {
            const responseData = response.data;
            if (responseData && responseData.length > 0) {
              const baselineList = responseData;
              setBaselines(baselineList);
            }
          }
        }
      } catch (err) {
        Logger.error("Error while setting as default baseline: ", err);
      } finally {
        setIsLoading(false);
      }
    }

    if ((success && success.BaselineID !== undefined) || data !== "CONFIRM") {
      const { NormalizationTags } = baselineModal;
      Object.entries(NormalizationTags).map(tag => {
        NormalizationTags[tag[0]].value = "";
        NormalizationTags[tag[0]].error = "";
      });
      setbaselineModal({
        ...baselineModal,
        NormalizationTags,
        Timezone: LOCAL_TIME_ZONE,
        Title: "",
        Date: "",
        BaselineValuesSetting: baselineModal.BaselineValuesSetting
      });
      validateFields = {};
      validateFields.Timezone = LOCAL_TIME_ZONE;
      setTitleError("");
      setValidateSuccessfull(false);
      setIsFetchReady(false);
      setIsBaselineFormOpen(data === "RESET");
    } else {
      setIsAddEnabled(false);
    }
  };

  const isUniqueTitleName = value => {
    const values = baselines.filter(baseline => baseline.Name === value);
    return values.length === 0;
  };

  const onTitleChange = value => {
    checkIsTitleValid(value);
  };

  const checkIsTitleValid = value => {
    setTitleError("");
    setbaselineModal({ ...baselineModal, Title: value });
    const valueLength = value.trim().length;

    if (valueLength < MIN_TITLE_LIMIT || valueLength > MAX_TITLE_LIMIT) {
      setTitleError(BaselineStrings.titleLength);
    } else if (!isUniqueTitleName(value)) {
      setTitleError(BaselineStrings.nameExist);
    }
  };

  const onDateChangeManullay = value => {
    const isValidDate = moment(value, DATE_TIME_SECONDS_FORMAT, true).isValid();
    if (isValidDate || !value) {
      setSelectedDate(value);
      setbaselineModal({ ...baselineModal, Date: value });
    }
    setIsDateTimeInvalid(!isValidDate);
  };

  const onTimeChange = value => {
    if (value === null && selectedDate) {
      selectedDate.setHours(0, 0, 0);
      setbaselineModal({ ...baselineModal, Date: selectedDate });
    } else {
      setSelectedDate(value);
      setbaselineModal({ ...baselineModal, Date: value });
    }
  };

  const onBaseValueTypeChange = event => {
    if (event.target.name === "baselineValuesSetting") {
      setbaselineModal({ ...baselineModal, BaselineValuesSetting: event.target.value });
      const isFetchReady = checkFetchReady(baselineModal.Date);
      setIsFetchReady(isFetchReady);
      if (baselineModal.BaselineValuesSetting !== "manually") setIsFetchReady(false);
      else setIsEditTagsEnabled(false);
    }
  };

  const handleTimeStampChange = (keyV, value) => {
    setbaselineModal({ ...baselineModal, [keyV]: value });
    validateFields[keyV] = value;

    if (selectedDate !== null && validateFields.Timezone && validateFields.Date) {
      setIsFetchReady(true);
    } else {
      setIsFetchReady(false);
    }
  };

  const handleValidate = () => {
    if (selectedDate !== null && baselineModal.Timezone) {
      getBaselineValues();
    } else {
      setIsFetchReady(false);
    }
  };

  const handleChange = (value, key) => {
    const hasLetters = /[a-zA-Z]/g;
    const hasSpecialChar = /[!@#$%^&*]/g;
    const normalizationTags = { ...baselineModal.NormalizationTags };
    value = value.indexOf(".") >= 0 ? value.substr(0, value.indexOf(".")) + value.substr(value.indexOf("."), 3) : value;
    value = value.replace(hasLetters, "").replace(hasSpecialChar, "");
    normalizationTags[key].value = value;
    normalizationTags[key].error = value === "" ? InputErrorStrings.required : "";
    setbaselineModal({ ...baselineModal, normalizationTags });
  };

  const handleTagChange = (keyT, value) => {
    const normalizationTags = { ...baselineModal.NormalizationTags };
    normalizationTags[keyT].tag = value;
    setbaselineModal({ ...baselineModal, normalizationTags });
  };

  const onEditTagClicked = () => {
    setIsEditTagsEnabled(!isEditTagsEnabled);
  };

  const handleEditTags = () => {
    const editTags = async () => {
      const normalizationTags = baselineModal.NormalizationTags;
      const normalizationTagIds = Object.entries(normalizationTags).map(tag => {
        const tags = { Function: tag[0], TagId: tag[1].tag.TagId };
        return tags;
      });
      const editTagsObject = { Mapping: normalizationTagIds };
      try {
        const response = await editNormalizationTags(editTagsObject);
        if (response.status >= 200 && response.status < 300) {
          setIsTagsUpdated(true);
          setIsEditTagsEnabled(false);
        }
      } catch (err) {
        Logger.log("handleEditTags - Error:", err);
      }
    };
    editTags();
  };

  const handleAddBaseline = async () => {
    let baselineData = null;
    try {
      setIsLoading(true);
      baselineData = await addNewBaseline(baselineModal);
      if (baselineData) {
        const updatedBaselines = [
          ...baselines,
          {
            ...baselineData,
            Type: baselineData.Type === BaselineStrings.manual ? BASELINE_TABLE_STRINGS.manual.toLocaleLowerCase() : BASELINE_TABLE_STRINGS.default,
            Group: BASELINE_TABLE_STRINGS.manual
          }
        ];
        updatedBaselines.sort((baseline1, baseline2) => baseline1.Id - baseline2.Id);
        if (setBaselines) setBaselines(updatedBaselines);
        setIsBaselineFormOpen(false);
      }
    } catch (err) {
      Logger.error("Error while creating new baseline: ", err);
      baselineData = null;
    } finally {
      setIsLoading(false);
    }
    return baselineData;
  };

  const getError = item => {
    if (item[1].error) {
      return item[1].error;
    } else if (validateSuccessfull && (item[1].value === "" || item[1].value === null)) {
      return InputErrorStrings.required;
    }
  };

  const getDialogTitle = () =>
    isViewOnlyView
      ? editBaselineName
      : isCloneView
      ? BaselineStrings.addBaseLine.replace("[%]", valueStrings.clone)
      : BaselineStrings.addBaseLine.replace("[%]", valueStrings.add);

  const getCofirmBtnText = () =>
    isViewOnlyView
      ? BaselineStrings.cloneBaseline
      : isCloneView
      ? BaselineStrings.addNewBaseline.replace("[%]", valueStrings.clone)
      : BaselineStrings.addNewBaseline.replace("[%]", valueStrings.add);

  const getDefaultBaselineBtnText = () => {
    if (isViewOnlyView) {
      return isAdmin && baselineModal.Type === BaselineStrings.manual ? BaselineStrings.setAsDefaultBaseline : "";
    }
    return "";
  };

  return (
    <>
      <DupontDialog
        open
        title={getDialogTitle()}
        subTitle={isViewOnlyView ? BaselineStrings.baselineReadOnlyMsg : null}
        customTitle={isViewOnlyView ? null : <BaselineReadMore />}
        showisRequired={!isViewOnlyView}
        cancelBtnText={valueStrings.cancel}
        resetBtnText={isViewOnlyView || isCloneView ? "" : userProfileStrings.reset}
        confirmBtnText={getCofirmBtnText()}
        defaultBtnText={getDefaultBaselineBtnText()}
        onClose={handleCloseBaselineForm}
        maxWidth="xl"
        isOverlayLoader={isLoading}
        confirmDisabled={isAddEnabled}
      >
        {isViewOnlyView ? (
          <BaselineReadOnlyView baselineData={baselineModal} />
        ) : (
          <div className="add-baseline-form">
            <InputBox
              labelText={`${BaselineStrings.baseLineTitle}*`}
              placeholder={BaselineStrings.placeholder}
              value={baselineModal.Title}
              onChange={onTitleChange}
              errorMsg={titleError}
              customClass="width30 position-relative "
              maxLength={50}
            />
            <div>
              {BaselineStrings.baselineValue}
              <span>
                {isSettingTimestamp || !baselineModal.BaselineValuesSetting
                  ? BaselineStrings.baselineValueMessage
                  : BaselineStrings.baselineManualMessage}
              </span>
              <div className="baseline-value-container">
                <div onChange={onBaseValueTypeChange}>
                  <div className="timestamp-display">
                    <label className="radio-label-font radiocontainer">
                      {BaselineStrings.timestamp}
                      <input
                        className="radioLabel"
                        type="radio"
                        defaultChecked={Boolean(isSettingTimestamp)}
                        value="timestamp"
                        name="baselineValuesSetting"
                      />
                      <span className="radioButton" />
                    </label>

                    <Dropdown
                      disabled={!isSettingTimestamp}
                      labelText={BaselineStrings.timeZone}
                      value={baselineModal.Timezone}
                      options={timezoneOptions}
                      inputValue={baselineModal.Timezone}
                      onChange={(value, reason) => handleTimeStampChange("Timezone", value, reason)}
                      maxLimit = {600}
                    />

                    <DupontDatePicker
                      selected={baselineModal.Date}
                      onChange={onDateChangeManullay}
                      startDate={baselineModal.Date | new Date()}
                      dateFormat={DATE_FORMAT_SMALL}
                      value={baselineModal.Date}
                      label={valueStrings.date}
                      maxDate={new Date()}
                      labelClass="dupont-form-label wrapText"
                      className={"custom-input width100"}
                      {...DatePickerConfig}
                    />

                    <DupontDatePicker
                      selected={baselineModal.Date}
                      onChange={onTimeChange}
                      timeCaption={valueStrings.time}
                      labelClass="dupont-form-label wrapText"
                      className={"custom-input width100"}
                      label={valueStrings.timeWithFormat}
                      {...TimePickerConfig}
                    />
                    <DupontButton type="tertiary" customClass="fetch-button " disabled={!validateState} onClick={handleValidate}>
                      {BaselineStrings.retrieve}
                      <img className="padding8" src={validateButtonImage} />
                    </DupontButton>
                  </div>
                  <hr />
                  <div className="manual-tag-container">
                    <label className="radio-label-font radiocontainer ">
                      {BaselineStrings.manually}
                      <input className="radioLabel" type="radio" value="manually" name="baselineValuesSetting" />
                      <span className="radioButton" />
                    </label>
                    <div className="manual-tag-display">
                      {baselineModal?.NormalizationTags &&
                        Object.entries(baselineModal.NormalizationTags).map((item, index) => (
                          <div className="d-flex" key={`${item[0]}-${index}`}>
                            <TagDropdown
                              customClass="tag-dropdown__width"
                              labelText={`${item[1].label} (${tagsAsObj[item[1]?.tag?.TagId]?.Units})`}
                              disabled={!isEditTagsEnabled}
                              tagValue={item[1].tag}
                              tagList={tagsList}
                              onTagChange={(value, reason) => {
                                handleTagChange(item[0], value, reason);
                              }}
                            />
                            <InputBox
                              customClass="tag-input"
                              disabled={!isSettingManually}
                              name={item[0]}
                              value={item[1].value === null ? "" : item[1].value}
                              errorMsg={getError(item, item[1].tag)}
                              onChange={value => handleChange(value, item[0])}
                            />
                          </div>
                        ))}

                      {isAdmin && (
                        <DupontButton
                          type="tertiary"
                          customClass="fetch-button"
                          disabled={!isSettingManually}
                          onClick={isEditTagsEnabled ? handleEditTags : onEditTagClicked}
                        >
                          {isEditTagsEnabled ? BaselineStrings.saveTag : BaselineStrings.editTag}
                          {<img src={editButtonImage} />}
                        </DupontButton>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </DupontDialog>
    </>
  );
}
const mapStateToProps = ({ tags, poll }) => ({
  tagsList: tags.tags,
  systemsStatus: poll.systemsStatus
});
export default connect(mapStateToProps)(AddBaseLineModal);
